<template>
  <el-dialog :visible.sync="visible" class="editDialog" :title="title" :close-on-click-modal="false" @close="close" @open="getOpen">
    <el-form :model="detail" class="addDetail" :rules="rules" ref="detail" label-width="100px">
      <el-form-item label="建筑名称" prop="name">
        <el-input placeholder="请输入建筑名称" v-model="detail.name" maxlength="200">
        </el-input>
      </el-form-item>
      <el-form-item label="建筑类型" prop="type">
        <el-select :popper-append-to-body="false" v-model="detail.type" placeholder="请选择建筑类型" clearable>
          <el-option v-for="item in buidingTypeArr" :key="item.id" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <p style="margin-top: 30px; display: flex; justify-content: flex-end">
      <button class='w_next_button cancelButton' @click.stop="cancel">取消</button>
      <button class='w_next_button confirmButton' style="margin-left: 20px" @click.stop="confirmSubmit">确认</button>
    </p>
  </el-dialog>
</template>

<script>
export default {
  name: 'buildingDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    selectBuilding: {
      type: Object,
      default() {
        return {}
      }
    },
    selectedNode: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: '请输入建筑名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择建筑类型', trigger: 'change' }]
      },
      detail: {},
      visible: this.value,
      buidingTypeArr: [
        {
          label: '建筑结构',
          value: 0
        },
        {
          label: '安装点',
          value: 1
        }
      ]
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    title() {
      if (this.status == 'adding') {
        return '新增楼宇信息'
      } else if (this.status == 'editing') {
        return '编辑楼宇信息'
      }
    }
  },
  methods: {
    setCurrentValue(val) {
      let data = this.data
      if (this.status == 'editing') {
        this.detail = data
      } else if (this.status == 'adding') {
        this.detail = {}
        this.$set(this.detail, 'inspectionResultRule', '-1')
      }
      this.visible = val
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    close() {
      this.detail = {}
      this.$nextTick(() => {
        this.$refs.detail.resetFields()
      })
    },
    cancel() {
      this.close()
      this.visible = false
    },
    confirmSubmit() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          if (this.status == 'adding') {
            this.$axiospost('extra/areaBuilding', {
              ...this.detail,
              areaId: this.selectedNode.data.id,
              parentId: this.selectBuilding ? this.selectBuilding.id : null
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('添加成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          } else {
            this.$axiosput('extra/areaBuilding', {
              id: this.detail.id,
              name: this.detail.name,
              type: this.detail.type
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('编辑成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/buildingManage/buildManage/buildingDialog.vue